import React from 'react';
import { Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className='footer-container'>
        <div className='footer-section'>
          <div className='footer-element'>
            <Typography>
              <a href='https://bite-app.s3.amazonaws.com/pdf/BITE+Privacy.pdf' rel='noreferrer' target={'_blank'} style={{ color: '#0E8BFF' }}>
                Privacy Policy
              </a>
            </Typography>
          </div>
          <div className='footer-element'>
            <Typography>
              <a href='https://bite-app.s3.amazonaws.com/pdf/BITE+Terms+of+Use+2023.pdf' rel='noreferrer' target={'_blank'} style={{ color: '#0E8BFF' }}>
                Terms of Use
              </a>
            </Typography>
          </div>
          <div className='footer-element'>
            <Typography>
              <a href='https://www.bitedata.io/contact' rel='noreferrer' target={'_blank'} style={{ color: '#0E8BFF' }}>
              Contact Support
              </a>
            </Typography>
          </div>
        </div>
        <div className='footer-element'>
          <Typography className='copyright-text'>
            Copyright © 2025 Bite, All rights reserved.
          </Typography>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
